import styled from "styled-components";
import { IconButton } from "@similarweb/ui-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow, FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Layout = styled(FlexColumn)`
    justify-content: space-evenly;
    height: 100%;
`;

export const Title = styled(FlexRow)`
    margin: 7px auto 5px;
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
    max-width: 456px;
    justify-content: center;
`;

export const ContentContainer = styled.div<{ isDisplayed: boolean }>`
    height: 35%;
    display: ${(props) => (props.isDisplayed ? "flex" : "none")};
    justify-content: center;
`;

export const TextContainer = styled(FlexColumn)<{ isDisplayed: boolean }>`
    height: 35%;
    display: ${(props) => (props.isDisplayed ? "block" : "none")};
`;

export const Text = styled.p`
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    margin: 0 auto;
    width: 65%;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: center;
    ${setFontVariant("tooltip", colorsPalettes.carbon[400])};
`;

export const CreationButton = styled(IconButton)`
    margin: 0 auto 5px auto;
    ${setFontVariant("button", colorsPalettes.blue[400])};
    transition: 0.2s;

    &.hovered {
        background-color: ${colorsPalettes.carbon[200]}33;
    }
`;
